import "./space.scss";

function Space({ size="sm" }) {
  return <div className={`Space Space-${size}`}></div>;
}
export default Space;